import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  assignedTaskStore,
  dealStore,
  primaryCustomerStore,
  taskStore,
  userStore,
  vehicleFromIndexerStore,
  vehicleListingStore,
} from '@/models/stores';
import { taskStoreV2, taskTemplateStore } from '@/models/stores/tasks-v2.ts';
import { useEffect } from 'react';

const useMyTasksPageHydrateLocal = () => {
  const isMyTasksPageActive = isPageActive(PAGE_ROUTES.MY_TASKS);

  useEffect(() => {
    if (!isMyTasksPageActive) {
      return;
    }

    const hydrateTasks = async () => {
      await Promise.all([
        // Dev note: this can be optimized to make this my tasks specific hydration for more efficiency
        assignedTaskStore.hydrateLocal(),
        taskStore.hydrateLocal(),
        taskStoreV2.hydrateLocal(),
        taskTemplateStore.hydrateLocal(),
        dealStore.hydrateLocal(),
        userStore.hydrateLocal(),
        primaryCustomerStore.hydrateLocal(),
        vehicleFromIndexerStore.hydrateLocal(),
        vehicleListingStore.hydrateLocal(),
      ]);
    };

    hydrateTasks();
  }, [isMyTasksPageActive]);
};

export default useMyTasksPageHydrateLocal;
